export default "__VITE_ASSET__DEVhaTzk__"